export default __webpack_public_path__ + "static/bg-contact-d50155cfa519d2f5b50b446621e378b5.jpeg";